import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
// components
import MNPG from "./MNPG";
// type
import { TMainPageLayoutV3 } from "../type";
import TOutletContext from "@/cms/types/TOutletContext";


const MNPG011 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG011.rendered: ", props);

    const { _showLoader } = useOutletContext<TOutletContext>();

    useEffect(() => { return () => { _showLoader(); }},[]);

    if ( !props.template || !props.params?.["contentDetails"] ) return null;

    return (
        <MNPG templates={props.templates} mapLayoutName={props.template.mapLayoutName} parentId={props.template.id} params={props.params} />
    )
}

export default MNPG011;
